import React from "react";
import { Title, TermsContainer } from "../../../CommonStyles";
import {
  TextWithOpacity,
  P,
  ListMain,
  LiTitle,
  ListSec,
  LiTextUnderline,
} from "../PolicyTerms/style";

const PrivacyPolicyEng = () => {
  return (
    <TermsContainer lngDirection="eng">
      <Title>PRIVACY POLICY</Title>
      <TextWithOpacity>January 2020</TextWithOpacity>

      <P>
        Zikaron BaSalon, a registered foundation No. 580662070 (hereinafter:
        “Zikaron BaSalon”) or “we/us”), sees importance in maintaining the
        privacy of the surfers and makes efforts to appropriately protect and
        safeguard information about the surfers and their privacy. The use of
        the websites: <a href="zikaronbasalon.com">zikaronbasalon.com</a>,{" "}
        <a href="zikaronbasalon.org">zikaronbasalon.org</a>,{" "}
        <a href="zikaronbasalon.herokuapp.com">zikaronbasalon.herokuapp.com</a>{" "}
        (hereinafter jointly: “the website”) is subject to the privacy policy
        detailed hereinafter (hereinafter: “the privacy policy”).
      </P>
      <P>
        The privacy policy is worded in the masculine gender however is designed
        for any person surfing on the website, women and men equally
        (hereinafter: “you”, “the user”/s” or “the surfer/s”). Surfing and/or
        use by you of the website in any form, constitutes your consent and your
        confirmation to that stated in the privacy policy hereinafter. If you do
        not agree with the privacy policy of the website, in entirety or in
        part, you are not permitted to make use of the website for any objective
        whatsoever and you shall not have any plea, claim and/or demand
        vis-à-vis Zikaron BaSalon in regard to the issues detailed hereinafter
        and in general.
      </P>
      <P>
        If you are under the age of 18, please read the privacy policy
        thoroughly and meticulously together with your parents or another
        guardian. If you or your parents do not agree with the privacy policy in
        entirety or in part, you are not permitted to make use of this website
        for any objective whatsoever.
      </P>
      <P>
        The procedures according to which Zikaron BaSalon operates for
        collection and use of the information are detailed hereinafter:
      </P>

      <ListMain>
        <li>
          <P>
            <LiTitle>THE INFORMATION THAT WE COLLECT </LiTitle>
          </P>
          <ListSec>
            <li>
              The privacy policy is imposed on: (a) the data that you shall
              provide as part of the registration process to the website (for
              example: name, address, various contact details, including
              telephone and email).
            </li>
            <li>
              In the event that you register via Facebook or via any other third
              party, we shall have access also to your data known to the third
              party through which you registered to the website; (b) the data
              transferred by you during use of the website; (c) the data
              collected about the surfers, including during surfing on the
              website and/or during the use of the services offered through it,
              such as information relating to the surfer’s personal computer,
              the IP address, the mobile device, the operating system and files,
              and the geographical location; (d) the search history of the
              surfers on the website including viewing of video clips and
              registration to meetings (hereinafter: “the information”).
            </li>
            <li>
              The information (as it shall be transferred from time to time)
              shall be saved on Zikaron BaSalon’s database for as long as it is
              required for implementation of the objectives of the database or
              for as long as Zikaron BaSalon sees fit to save it at its sole
              discretion. Provision of the information by you to Zikaron BaSalon
              is under your sole responsibility, wish and consent.
            </li>
            <LiTextUnderline>
              It shall be clarified that there is no duty on your part to
              transfer information about you to Zikaron BaSalon. However,
              without transfer of information as aforementioned, Zikaron BaSalon
              shall not be able to enable you to participate in meetings (as
              defined in the regulations).
            </LiTextUnderline>
            <li>
              You may contact Zikaron BaSalon at any time by email{" "}
              <a href="mailto:info@zikaronbasalon.com">
                info@zikaronbasalon.com
              </a>{" "}
              and request to delete or amend the information relating to you
              that is saved on the database. You declare that you are aware that
              without transfer of the details appearing in the mandatory fields,
              you shall not be able to use the services that require
              registration.
            </li>
            <li>
              The information that you shall transfer at the time of
              registration to the website shall not be transferred to third
              parties apart from that detailed in the privacy policy
              hereinafter.{" "}
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>TRANSFER OF INFORMATION</LiTitle>
          </P>
          <ListSec>
            <li>
              Zikaron Basalon shall abstain from transfer of your data to third
              parties, unless you have given your explicit consent, or in the
              event of legal disputes between you and Zikaron BaSalon, or in the
              event that you carried out an action on the website contrary to
              law, or in the event in which a judicial order shall be received
              ordering the transfer of the information as aforementioned.
            </li>
            <li>
              You confirm that you are aware that Zikaron BaSalon, subject to
              any law, could transfer the information that it collects to
              service providers, business partners or subcontractors
              (hereinafter: “third parties”) with the objective of: (1)
              assisting Zikaron BaSal;on in operating and/or maintaining the
              website; (2) organizing the meetings as defined in the
              regulations; (3) providing you with specific details. Zikaron
              BaSalon shall obligate these third parties not to make use of the
              information apart from organization of meetings and the website
              activity as aforementioned.
            </li>
            <li>
              We could transfer our database/s to third parties in the event of
              sale of our assets and/or our activity or part of it, subject to
              the fact that the entity who shall come in place of Zikaron
              BaSalon shall take upon itself to carry out the provisions of this
              privacy policy in full. In such a case we shall notify you of such
              and we shall act pursuant to law.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>HOW DO WE USE THE INFORMATION</LiTitle>
          </P>
          <ListSec>
            <li>
              Zikaron BaSalon and/or third parties pursuant to its request are
              permitted to act with the database pursuant to the provisions of
              law and to make use of the database for the purpose of improving
              the website, the services and the content that it offers, and also
              for the purpose of making contact with surfers on the website. You
              agree and confirm by the very transfer of the information that
              Zikaron BaSalon shall be permitted to save the details transferred
              by you in its database and additional information that shall be
              accumulated about you, for the purpose of use as aforementioned
              and as detailed hereinafter: (a) organization of meetings; (b)
              response to questions, making contact and sending notices to
              participants (including assessment of your satisfaction after a
              meeting); (c) for purposes of development of new ventures,
              analysis of statistical information (as stated in Section 3.3
              hereinafter) and its transfer to third parties in favour of
              improvement of the existing contents, segmentation and analyses of
              digital media; (d) prevention of fraud, protection of the website
              security and its content and handling of any other problem in
              regard to the website.
            </li>
            <li>
              Zikaron BaSalon shall be permitted to use the information, inter
              alia, for the purpose of direct mailing of information and
              contents to the surfers (by means of email and/or push
              notification alerts and/or messages to the mobile telephone and/or
              notices via social networks, and/or via the Israeli postal
              system), including advertising material on behalf of Zikaron
              BaSalon. When registering your details on the website you are
              requested to approve receipt of advertising information. Inasmuch
              as you do not wish to continue to receive these notices, you may
              remove yourself from the distribution list at any time by email.
            </li>
            <li>
              By analysis of the information that we receive we and/or our
              service providers and/or subcontractors could collect statistical
              data from diverse users (hereinafter: “the statistical data”). The
              statistical data help us in examining trends and the surfer’s
              requirements, thus we shall be able to correlate the contents of
              the website with the surfer’s desires. We could share the
              statistical data with our partners, pursuant to the commercial
              terms that we determine at our sole discretion. Furthermore, we
              could analyze the statistical data by means of software that
              provide information services and statistical analysis such as
              Google Analytics. We use the information that we receive from
              Google Analytics to improve the system. The information that
              Google Analytics collects about your use of the system is subject
              to the terms of use and privacy policy of Google Analytics, as
              they shall be updated from time to time, which appear in the links
              hereinafter:
              <a href="http://www.google.com/analytics/terms/us.html">
                http://www.google.com/analytics/terms/us.html
              </a>{" "}
              <a href="http://www.google.com/policies/privacy">
                http://www.google.com/policies/privacy
              </a>
            </li>
            <li>
              Pursuant to the Protection of Privacy Law, 5741-1981, you are
              permitted to request to study the information that we have
              collected about you, and if you find that the information is
              incomplete, incorrect, unclear or not updated, you are permitted
              to request its correction or deletion. Zikaron BaSalon shall
              delete in such a case only the information required in order to
              contact you however shall save the information required for
              administration of its activity, including documentation of the
              meetings that have been held. Inasmuch as you wish to study or
              update or delete as stated in this section, please contact us by
              email at{" "}
              <a href="mailto:info@zikaronbasalon.com">
                info@zikaronbasalon.com
              </a>
              , and your request shall be handled within fourteen (14) working
              days.
            </li>
            <li>
              Zikaron BaSalon uses cookies for the purpose of the ongoing
              operation of the website, as well as in order to collect
              statistical data about the use of the website, to correlate the
              website to your personal preferences, for information security and
              to verify details. Cookies are small text files stored by Zikaron
              BaSalon server on the hard disk of the computer on which the user
              uses by means of his browser, with the objective of providing the
              user with a faster or more efficient service and save him the need
              to enter his personal details every time he enters the website. We
              use cookies for the purpose of operating the website, for example:
              in order to improve the website performance and in order to
              document your entries and exits from the website,. These are
              session cookies and they are deleted every time that you close
              down your browser.
            </li>
            <li>
              The definitions of every browser include an option not to agree to
              receive cookies and to delete existing cookies. You must take into
              consideration that such an action could make it difficult for you
              to use the website. If you know how to do this, check the help
              file of the browser that you use.
            </li>
            <li>
              Zikaron BaSalon is permitted to allow third parties to administer
              an advertising system on the website. It is possible that the
              messages that you shall view while you are visiting the website
              are coming from the computers of those same third parties. In
              order to manage these advertisements, these third parties are
              permitted to place cookies on your computer. The cookies enable
              them to collect information about the websites on which you viewed
              the advertisements that they placed and about advertisements on
              which you clicked. The use that these third parties make of
              cookies is subject to their privacy policies and not the Zikaron
              BaSalon privacy policy.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>HOW DO WE PROTECT THE INFORMATION </LiTitle>
          </P>
          <ListSec>
            <li>
              Zikaron BaSalon implements advanced protection mechanisms in order
              to secure the information found on Zikaron Basalon’s computerized
              system including the internet website. It shall be emphasized that
              hacking into Zikaron Basalon’s computerized systems constitutes a
              criminal offence pursuant to the laws of the State of Israel the
              penalty for which is five years imprisonment. However, as with
              every computerized database, Zikaron BaSalon cannot guarantee
              absolute protection from hacking into its computer systems. If
              notwithstanding the meticulous security measures taken by Zikaron
              BaSalon information about you saved on the Zikaron BaSalon
              databases shall reach any entity whatsoever, you shall not have in
              this matter any claim vis-à-vis Zikaron BaSalon or its
              representative.
            </li>
            <li>
              We shall correct and/or delete any information given to us by a
              user pursuant to a written request from the user to
              <a href="mailto:info@zikaronbasalon.com">
                info@zikaronbasalon.com
              </a>
              . From the moment that the information is deleted we shall not be
              able to reinstate it.
            </li>
            <li>
              Every surfer on the website undertakes not to carry out any action
              on Zikaron BaSalon’s computerized system that is not in accordance
              with law. Inasmuch as a concern is raised buy Zikaron BaSalon as
              to abuse of its computerized system, it shall report such to the
              relevant authorities.
            </li>
            <li>
              It shall be clarified that Zikaron BaSalon shall not bear any
              liability if use is made in the name of a user and the password of
              any of the users on the website by one who is not authorized for
              such, and you are required to safeguard this information securely.
              In order to guarantee an optimal level of security it is
              recommended to change your password from time to time.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>AMENDMENTS</LiTitle> Zikaron BaSalon reserves its right to
            update the privacy policy from time to time, at its sole discretion,
            and without the need to notify of such in advance. The validity of
            the amendment shall be applied from the time it is published on the
            website. It is your duty to know the updates to the privacy policy
            from time to time. The wording of the privacy policy, as it is
            detailed on the website, is the determining wording at all times.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>MISCELLANEOUS</LiTitle>
          </P>
          <ListSec>
            <li>
              Zikaron BaSalon is permitted to assign and/or transfer and/or
              convert its rights pursuant to this privacy policy, or part of it,
              to any corporation or third party entity at its sole discretion
              and without the need to notify of such in advance.
            </li>
            <li>
              The laws of the State of Israel shall be imposed on this privacy
              policy. The sole jurisdiction for any matter relating to this
              privacy policy is the authorized courts in the Tel Aviv-Jaffa
              area.
            </li>
            <li>
              If any of the terms of this privacy policy shall be found to be
              illegal, invalid or unenforceable for any reason whatsoever, this
              term shall be deleted and its deletion shall not have an effect on
              the legality of the rest of the terms of this privacy policy and
              their validity.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>COMMENTS AND QUESTIONS </LiTitle> If you have any questions
            or comments regarding our privacy policy, please contact us at{" "}
            <a href="mailto:info@zikaronbasalon.com">info@zikaronbasalon.com</a>
          </P>
        </li>
      </ListMain>
    </TermsContainer>
  );
};

export default PrivacyPolicyEng;
